/* eslint-disable */
import { useTranslation } from "react-i18next";
import {useEffect, useState} from 'react';
import ECharts from 'echarts-for-react';
import Papa from 'papaparse';
import { Chip } from '@mui/material';

import MainCard from 'components/MainCard';
import { getDownloadDirectByQuery } from 'components/axios/fileManagerAxios';
import dayjs from "utils/dayjs";

const chartDataInit = {
  // darkmode:true,
  textStyle : {
      color : '#ffffff'
  },
  tooltip: {
    trigger: 'axis'
  },
  legend: {
      data : [],
      left : 'center',
      top: 0,
      backgroundColor : '#fff'
  },
  grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
  },
  xAxis: {
      type: 'category',
      boundaryGap: false,
      data: []
  },
  yAxis: {
      type: 'value'
  },
  series: []
}

function CSVReaderGraph({sensorId, type="default", isPrinting=false}) {
  const { t } = useTranslation();

  const [options, setOptions] = useState(chartDataInit);
  const [file, setFile] = useState(null);
  const [remainLife, setRemainLife] = useState(0); 

  useEffect(()=>{
    getDownloadDirectByQuery({fileGroup:"LER",id:sensorId}).then((res) => {
      return res;
    }).then((blob) => {
      setFile(blob);
    })
    .catch((err) => {
        setFile(null);
    });
  },[sensorId]);

  useEffect(() => {
    if (!file) return;
    handleParse();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [file]);
  
  const handleParse = () => {
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async ({ target }) => {
      const csv = Papa.parse(target.result, { header: true });
      const parsedData = csv?.data ?? [];
      if (parsedData.length === 0) return;

      const columns = Object.keys(parsedData[0]);
      const datas = parsedData[0];

      setRemainLife(parseInt(datas[columns[3]]) || 0);

      const chartDataCopy = {
        ...chartDataInit,
        xAxis: { ...chartDataInit.xAxis, data: [] },
        series: [],
        legend: { ...chartDataInit.legend, data: [] },
      };

      let lifeSpans = [];
      let remainLifeSpans = [];

      parsedData.forEach(row => {
        if (!row[columns[0]]) return;

        chartDataCopy.xAxis.data.push(row[columns[0]]);
        lifeSpans.push(Math.round((row[columns[1]] || 0) * 100) / 100);
        remainLifeSpans.push(Math.round((row[columns[2]] || 0) * 100) / 100);
      });

      chartDataCopy.series.push({
        name: t('message.common.text.lifespan.index'),
        type: 'line',
        areaStyle: {},
        data: lifeSpans
      });

      chartDataCopy.series.push({
        name: t('message.common.text.expect.lifespan.index'),
        type: 'line',
        areaStyle: {},
        data: remainLifeSpans
      });

      chartDataCopy.legend.data.push(
        t('message.common.text.lifespan.index'),
        t('message.common.text.expect.lifespan.index')
      );

      setOptions(chartDataCopy);
    };
    reader.readAsText(file);
  };

  if (!file || !options.series?.length) return null;

  return (
    <>
    <MainCard style={{marginTop:"10px"}} content={false}>
        <Chip label={`${t('message.common.chip.expect.lifespan')} (${t('message.common.chip.remain.lifespan')}:${remainLife}${t('message.common.text.month')})`} color="primary" />
        {isPrinting ?
        <ECharts
          option={options}
          opts={{ renderer: 'svg', width:"1000px", height: '250px' }}
          />
        :
        <ECharts
          option={options}
          opts={{ renderer: 'svg', height: '250px' }}
          />
        }
    </MainCard>
    </>
  )
}
 
export default CSVReaderGraph;